export default [
"Starter",
"Route 2",
"Neuvartia-Wald",
"Route 3",
"Route 22",
"Santalune City – Angel",
"Route 4 ",
"Illumina City – Static (Kanto-Starter)",
"Route 5 ",
"Route 6 ",
"Magnum-Opum-Palast",
"Vanitéa – Angel",
"Route 7",
"Relaxo",
"Verbindungs-Höhle",
"Petrophia – Angel",
"Route 8",
"Funkelnde Höhle",
"Petrophia Labor (Fossil)",
"Route 9 – Gras",
"Leuchthöhle",
"Leuchthöhle (Geschenk)",
"Cyllage City – Angel",
"Route 10",
"Cromlexia – Angel",
"Flare Geheimbasis",
"Route 11",
"Spiegelhöhle",
"Yantara City – Angel",
"Turm der Erkenntnis",
"Route 12",
"Azurbucht",
"Meerestitanen-Höhle",
"Route 13",
"Kalos-Kraftwerk",
"Route 14",
"Romantia – Angel",
"Route 15",
"Hotelruine",
"Route 16",
"Frosthöhle",
"Fractalia City – Angel",
"Route 17",
"Fluxia City – Angel",
"Route 18",
"Endhöhle",
"Batika City – Angel",
"Mosaia",
"Route 19",
"Route 20",
"Frescoville – Angel",
"Route 21",
"Siegesstraße",
"Route 23",
"Pokémon-Dorf",
"Geheimdungeon",
"Unbekannte Höhle",
"Siegesstraße",
"Umherziehende - Legendäre Vögel",
"Omega Höhle",
"Omega Höhle Static",
"Lucario (Static)",
"Arktos (Static)",
"Zygarde (Static)",
"Mewtu (Static)",
"Fossil-1",
"Fossil-2",
"Fossil-3",
"Fossil-4",
"Fossil-5",
"Geschenk-1",
"Geschenk-2",
"Geschenk-3",
"Geschenk-4",
"Geschenk-5",
"Extra-1",
"Extra-2",
"Extra-3",
"Extra-4",
"Extra-5",
"Shiny",
"Mistmon of the Year"
];